import React from 'react';
import { Select, Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useLocale } from '../contexts/LocaleContext';

const { Option } = Select;

interface LanguageSwitcherProps {
  type?: 'select' | 'button';
  style?: React.CSSProperties;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ 
  type = 'select', 
  style 
}) => {
  const { locale, setLocale } = useLocale();

  const languages = [
    { code: 'fa', name: 'فارسی', flag: '🇮🇷' },
    { code: 'en', name: 'English', flag: '🇺🇸' },
  ];

  const handleLanguageChange = (newLocale: string) => {
    console.log('LanguageSwitcher: Changing language to:', newLocale); // Debug log
    setLocale(newLocale);
  };

  const currentLanguage = languages.find(lang => lang.code === locale);

  if (type === 'button') {
    return (
      <Button
        icon={<GlobalOutlined />}
        onClick={() => {
          const nextLocale = locale === 'fa' ? 'en' : 'fa';
          console.log('LanguageSwitcher Button: Switching to:', nextLocale); // Debug log
          setLocale(nextLocale);
        }}
        style={style}
      >
        {currentLanguage?.flag} {currentLanguage?.name}
      </Button>
    );
  }

  return (
    <Select
      value={locale}
      onChange={handleLanguageChange}
      style={{ minWidth: 120, ...style }}
      suffixIcon={<GlobalOutlined />}
    >
      {languages.map((lang) => (
        <Option key={lang.code} value={lang.code}>
          {lang.flag} {lang.name}
        </Option>
      ))}
    </Select>
  );
};

export default LanguageSwitcher;
